<template>
  <span v-if="badge" :class="['brand', type]"></span>
</template>
<script setup>
  import { computed, defineProps } from 'vue'
  const props = defineProps({
    badge: {
      type: String,
      default: '',
    },
  })

  const originalBadgeList = ['original', 'exclusive', 'firstrun']

  const type = computed(() => {
    const badge = props.badge?.toLowerCase() ?? ''
    return originalBadgeList.includes(badge) ? 'wavve' : badge
  })
</script>
